import { shared } from './shared'
import type { Schema } from './types'

export const schema: Schema = {
  ...shared,
  'account-show-work-button': {
    default: true,
  },
  'customer-self-serve-credit': {
    default: true,
  },
  'show-saved-cards': {
    default: true,
  },
  'show-business-orders-view': {
    default: true,
  },
}
